import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedback: {
		id: 'spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback',
		defaultMessage: 'Give feedback',
		description: 'Link that opens the feedback dialog.',
	},
});
